import { SVGProps, Ref, forwardRef } from 'react';

export const HomeOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.9 21.2V9.8h7.3V15c0 2.9-.507 4.261-1.223 4.977S18.9 21.2 16 21.2zM13.1 9.646V21.2H8c-2.9 0-4.261-.507-4.977-1.223S1.8 17.9 1.8 15V9.443l5.266-5.831zM24 8v7c0 6-2 8-8 8H8c-6 0-8-2-8-8V8.75L7 1h10.003L24 7.997zm-2.543 0-5.2-5.2H8.8L14 8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
HomeOutlinedSize24Glyph.displayName = 'HomeOutlinedSize24Glyph';
